import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Depr: Topic With Any Parameter Present",
  order: 510,
};
